/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-04-07 15:43:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-11-19 15:26:00
 * @FilePath: \baishu_react_ui\src\components\BsyIconBtn\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import "./index.css";
import { BsyWidget } from "../BsyWidget";
import { BsyUtils } from "../../utils/Utils";

export default class BsyFormMultiTab extends BsyWidget {
  constructor(props) {
    super({
      baseCls: "bsy-form-multi-tab ",
      tabs: [],
      activeTabName: "",
      themeColor: "#0265FF",
      theme: "drop-down-type-one",
      items: [],
      onCreateTabItem: null,
      viewWidth: 780,
      canSort: !1,
      haspadding: !0,
      showRules: props.showRules,
      height: "auto",
      onTabClick: null,
      ...props,
    });
    this.uuid = `w${BsyUtils.UUID()}`;
    this.state = {
      selectTab: props.tabs.length > 0 && props.tabs[0].name,
      widthout: false,
      currIndex: 0,
    };
    this.form = props.form;
  }

  componentDidMount() {
    super.componentDidMount();
    this.listPosLeft = 0;
    let wrapperWidth =
      this.element.current.querySelector(".inner-wrapper").offsetWidth;
    let tablistWidth = 0;

    let res = this.element.current.querySelectorAll(".tab-list .tab-item");
    for (let index = 0; index < res.length; index++) {
      tablistWidth += res[index].offsetWidth;
    }

    let stylestr = this.grenderCss();
    if (stylestr) {
      this.style = document.createElement("style");
      this.style.innerHTML = stylestr;
      document.body.appendChild(this.style);
    }

    this.setState(
      {
        currIndex: 0,
        widthout: tablistWidth > wrapperWidth,
      },
      () => {
        this._dealMultiTabVisible();
      }
    );

    // console.log('BsyFormMultiTab', wrapperWidth, tablistWidth, this.options.tabs)
  }

  componentWillUnmount() {
    if (this.style) {
      document.body.removeChild(this.style);
    }
  }
  setTab = (tabs) => {
    this.options.tabs = tabs;
  };

  _dealMultiTabVisible = () => {
    var t = this.options;
    if (this.element.current) {
      if (BsyUtils.isObjectEmpty(t.tabs)) {
        this.element.current.classList.add("invisible");
      } else {
        this.element.current.classList.remove("invisible");
      }
    }
  };

  grenderCss = () => {
    const { theme = "drop-down-type-one", themeColor = "#0265FF" } =
      this.options;
    switch (theme) {
      case "drop-down-type-one": {
        return `.${this.uuid} .${theme} .tab-item:hover{color:${themeColor};}`;
      }

      case "drop-down-type-two": {
        var t = themeColor;
        var rgb = BsyUtils.hexToRgbJson(t);
        return `
          .${this.uuid} .${theme} .tab-item.active{
              color:rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.92)  !important;
              font-weight: 600  !important;
              border-top:2px solid ${t} !important;
              background:linear-gradient(to bottom, rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.24), #FFFFFF 50%, #FFFFFF 100%) !important;
          }
          .${this.uuid} .${theme} .tab-item:hover{
                color:rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.92);
          }
        `;
      }
      case "drop-down-type-three": {
        return `

          .${this.uuid} .${theme} .tab-item:hover{
                color:${themeColor} !important;
          }
          .${this.uuid} .${theme} .tab-item.active{
              color:#fff  !important;
              background:${themeColor} !important;
          }
          .${this.uuid} .${theme} {
            border-bottom: 2px solid ${themeColor} !important;
          }
        `;
      }
      case "drop-down-type-four": {
        return `
        .${this.uuid} .${theme} {
          border-bottom: 2px solid ${themeColor} !important;
        }
        .${this.uuid} .${theme} .tab-item:hover{
          color:${themeColor};
        }`;
      }
      default:
        return "";
    }
  };

  _slideTabList = (t) => {
    const { theme = "drop-down-type-one" } = this.options;
    var i = this.element.current.querySelector(".inner-wrapper").offsetWidth;
    let tablistWidth = 0;
    let res = this.element.current.querySelectorAll(".tab-list .tab-item");
    for (let index = 0; index < res.length; index++) {
      let nf = 0;
      switch (theme) {
        case "drop-down-type-one":
        case "drop-down-type-four": {
          nf = 15;
          break;
        }
        case "drop-down-type-three": {
          nf = 7;
          break;
        }
        default:
      }
      tablistWidth += res[index].offsetWidth + nf;
    }
    var e = tablistWidth;

    "right" === t
      ? e - -this.listPosLeft - i > i
        ? (this.listPosLeft -= i)
        : (this.listPosLeft = -(e - i))
      : "left" === t &&
        (-this.listPosLeft > i
          ? (this.listPosLeft += i)
          : (this.listPosLeft = 0));
    let tabres = this.element.current.querySelector(".tab-list");
    tabres.style.transform = `translateX(${this.listPosLeft}px)`;

    var leftEl = this.element.current.querySelector(".arrow.left");
    var rightEl = this.element.current.querySelector(".arrow.right");
    leftEl.classList.remove("disable");
    rightEl.classList.remove("disable");
    if (!this._isLeftArrowEnable()) {
      leftEl.classList.add("disable");
    }
    if (!this._isRightArrowEnable()) {
      rightEl.classList.add("disable");
    }
  };
  movePos = () => {
    const { currIndex } = this.state;
    const { theme = "drop-down-type-one" } = this.options;
    let wrapperWidth =
      this.element.current.querySelector(".inner-wrapper").offsetWidth;
    let tablistWidth = 0;

    let res = this.element.current.querySelectorAll(".tab-list .tab-item");
    let n = res.length > currIndex ? currIndex : res.length - 1;
    for (let i = 0; i <= n; i++) {
      if (res[i]) {
        let nf = 0;
        switch (theme) {
          case "drop-down-type-one":
          case "drop-down-type-four": {
            nf = 15;
            break;
          }
          case "drop-down-type-three": {
            nf = 7;
            break;
          }
          default:
        }
        tablistWidth += res[i].offsetWidth + nf;
      }
    }
    let tabres = this.element.current.querySelector(".tab-list");
    if (tablistWidth > wrapperWidth) {
      if (currIndex === res.length - 1) {
        tabres.style.transform = `translateX(-${
          tablistWidth - wrapperWidth
        }px)`;
      } else {
        let n1 = tablistWidth - wrapperWidth + res[n].offsetWidth;
        tabres.style.transform = `translateX(-${n1}px)`;
      }
    } else {
      tabres.style.transform = ``;
    }
  };

  _isLeftArrowEnable = () => {
    return this.listPosLeft < 0;
  };
  _isRightArrowEnable = () => {
    let wrapperWidth =
      this.element.current.querySelector(".inner-wrapper").offsetWidth;
    let tablistWidth = 0;

    let res = this.element.current.querySelectorAll(".tab-list .tab-item");
    for (let index = 0; index < res.length; index++) {
      tablistWidth += res[index].offsetWidth;
    }
    var t = tablistWidth - wrapperWidth;
    return -this.listPosLeft < t;
  };

  moveLeft = () => {
    this._slideTabList("left");
  };

  moveRight = () => {
    this._slideTabList("right");
  };

  setHideTabName = (tabname) => {
    var tabwidgets = this.element.current.querySelectorAll(
      ".bsy-widget-view." + tabname
    );
    BsyUtils.forEach(tabwidgets, function (t, e) {
      e.classList.add("tabhide");
    });
  };

  removeHideTabName = () => {
    var tabwidgets = this.element.current.querySelectorAll(".bsy-widget-view");
    BsyUtils.forEach(tabwidgets, function (t, e) {
      e.classList.remove("tabhide");
    });
  };

  refreshWithConfig = (tabs) => {
    this.options.tabs = tabs;
    let obj = {};
    if (!this.state.selectTab) {
      if (tabs && tabs.length) {
        obj.selectTab = tabs[0].name;
      }
    }
    this.setState(obj, () => {
      this._dealMultiTabVisible();
    });
  };

  setActiveTabName = (name) => {
    const { tabs } = this.options;
    let item = tabs;
    let selectIndex = 0;
    tabs.map((tab, index) => {
      if (tab.name == name) {
        item = tab;
        selectIndex = index;
      }
    });
    this.selectItem(item, selectIndex);
  };

  getActiveTabName = () => {
    return this.state.selectTab;
  };

  getSelectItem = () => {
    return this.state.selectTab;
  };

  selectItem = (item, index) => {
    this.setState(
      {
        selectTab: item.name,
        currIndex: index,
      },
      () => {
        this.form &&
          this.form._setLinkQuery &&
          this.form._setLinkQuery(item.name); //(item.name)
        this.form &&
          this.form._renderTabTextArea &&
          this.form._renderTabTextArea(item.name);
        this.movePos();
      }
    );
  };

  renderTabHeaderItem = (tab, i, visible) => {
    const { theme = "drop-down-type-one", themeColor = "#0265FF" } =
      this.options;
    const color = tab.name == this.state.selectTab ? themeColor : "";
    const cssname = tab.name == this.state.selectTab ? "active" : "";
    switch (theme) {
      case "drop-down-type-four":
        return (
          <div
            className={"tab-item " + cssname}
            style={{
              display: visible ? "" : "none",
            }}
            onClick={() => {
              this.selectItem(tab, i);
            }}
          >
            <div
              class="t-tab-title"
              style={{ background: cssname ? themeColor : "" }}
            >
              {tab.title}
            </div>
            <div
              class="t-triangle-down"
              style={{ borderTop: cssname ? "20px solid " + themeColor : "" }}
            ></div>
          </div>
        );
      case "drop-down-type-two":
        return (
          <div
            className={"tab-item " + cssname}
            style={{ display: visible ? "" : "none" }}
            onClick={() => {
              this.selectItem(tab, i);
            }}
          >
            {tab.title}
          </div>
        );

      case "drop-down-type-three":
        return (
          <div
            className={"tab-item " + cssname}
            style={{ display: visible ? "" : "none" }}
            onClick={() => {
              this.selectItem(tab, i);
            }}
          >
            {tab.title}
          </div>
        );

      default:
        return (
          <div
            className={"tab-item " + cssname}
            style={{ display: visible ? "" : "none", color }}
            onClick={() => {
              this.selectItem(tab, i);
            }}
          >
            {tab.title}
            <div className={"bar"} style={{ background: color }}></div>
          </div>
        );
    }
  };

  render() {
    const {
      cssName,
      css,
      tabs,
      items,
      haspadding,
      showRules,
      theme = "drop-down-type-one",
    } = this.options;
    const { widthout, currIndex } = this.state;

    // console.log('BsyFormMultiTab render tabs', tabs)

    return (
      <div
        className={cssName + (haspadding ? " has-padding " : " ") + this.uuid}
        style={css}
        ref={this.element}
      >
        <div className={`tab-list-wrapper ${theme}`}>
          {widthout ? (
            <div
              className={"arrow left " + (currIndex == 0 ? " disable " : "")}
              data-direction="left"
              onClick={(e) => {
                this.moveLeft();
              }}
            >
              <i className="icon-angleleft"></i>
            </div>
          ) : (
            ""
          )}

          <div className="inner-wrapper">
            <div className="tab-list">
              {tabs.map((tab, i) => {
                let visible = true;
                if (showRules) {
                  if (showRules.hasOwnProperty(tab.name)) {
                    visible = showRules[tab.name];
                  }
                }

                return this.renderTabHeaderItem(tab, i, visible);

                // return (
                //   <div
                //     className={
                //       "tab-item " +
                //       (tab.name == this.state.selectTab ? "active" : "")
                //     }
                //     style={{ display: visible ? "" : "none" }}
                //     onClick={() => {
                //       this.selectItem(tab, i);
                //     }}
                //   >
                //     {tab.title}
                //     <div
                //       className={"bar"}
                //       style={{ color: this.props.themeColor }}
                //     ></div>
                //   </div>
                // );
              })}
            </div>
          </div>
          {widthout ? (
            <div
              className={
                "arrow right " +
                (currIndex == tabs.length - 1 ? " disable " : "")
              }
              data-direction="right"
              onClick={(e) => {
                this.moveRight();
              }}
            >
              <i className="icon-angleright"></i>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="tab-content">
          <div className="multi-tab-widget-list">
            {this.props.onCreateTabItem
              ? items.map((e) => {
                  return (
                    <React.Fragment key={e.widget?.widgetName || e.widgetName}>
                      {this.props.onCreateTabItem(e, this.state.selectTab)}
                    </React.Fragment>
                  );
                })
              : null}
          </div>
        </div>
      </div>
    );
  }
}
